module.exports = __webpack_public_path__ + "img/result1.e1209a23.png";